import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import Breakpoints from 'themes/constants/breakpoints';
import { PATH_PREFIX } from 'routes/routes';

const Wrapper = styled.div`
    box-sizing: border-box;
    padding: ${({ theme }) => theme.paddings.paddingTop} 20px 10px;
    flex: 1;
    max-width: 100%;
    margin: 0 auto;
    @media only screen and (${Breakpoints.TABLET}) {
        padding: 70px 20px 10px;
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        max-width: 1440px;
        margin: 0 auto;
        padding: 80px 20px 10px;
    }
`;

const TextWrapper = styled.div`
    color: #4c4c4e;
    font-size: 16px;
    width: 100%;
    text-align: justify;
    padding-top: 10px;
    h1 {
        font-size: 20px;
    }
    h2, h3 {
        font-size: 18px;
    }
    a {
        color: #4c4c4e;
    }
    table {
        border-collapse: collapse;
        thead {
            text-align: center;
        }
        td {
            border: 1px solid currentColor;
            padding: 5px;
            text-align: left;
        }
    }
    ol {
        list-style: none;
        counter-reset: li;
        padding: 0;
        margin: 0;
    }

    ol > li:before {
        display: inline;
        counter-increment: li;
        content: counters(li,".") ". ";
        font-weight: bold
    }

    ul {
        margin: 0
    }

    li {
        text-align: justify;
        margin-bottom: 15px;
    }
    li span:has(table) {
        display: block;
        width: 100%;
        overflow: auto;
    }
    @media only screen and (${Breakpoints.TABLET}) {
        font-size: 18px;
        padding-top: 10px;
        h1 {
            font-size: 24px;
        }
        h2, h3 {
            font-size: 20px;
        }
    }
    @media only screen and (${Breakpoints.LAPTOP}) {
        font-size: 18px;
        h1 {
            font-size: 28px;
        }
        h2, h3 {
            font-size: 24px;
        }
    }
`;

const TextPage = ({ path }: { path: string }) => {
  const [text, setText] = useState('');

  useEffect(() => {
    setText('');

    axios.get(`${PATH_PREFIX}${path}`)
      .then((res) => {
        if (res.data) {
          setText(res.data);
        }
      })
      .catch(() => {});
  }, [path]);

  return (
    <Wrapper>
      <TextWrapper dangerouslySetInnerHTML={{ __html: text }} />
    </Wrapper>
  );
};

export default TextPage;
